<app-header-component [headerData] = "currentHeaderData" (closeModal)="closeModal()"></app-header-component>

<ion-content class="ion-padding">
  <div class="row">
    <div class="label">
      <div class="title">{{"modals.guest_count_modal.adult" | translate}}</div>
      <div class="subtitle">(12+ {{"modals.guest_count_modal.Years" | translate}})</div>
    </div>
    <div class="counter">
      <button type="button" class="btn" (click)="decrement('adult')" [disabled]="adult <= 1">−</button>
      <div class="value">{{ adult }}</div>
      <button type="button" class="btn" (click)="increment('adult')" [disabled]="adult >= 9">+</button>
    </div>
  </div>

  <div class="row">
    <div class="label">
      <div class="title">{{"modals.guest_count_modal.child" | translate}}</div>
      <div class="subtitle">(2-11 {{"modals.guest_count_modal.Years" | translate}})</div>
    </div>
    <div class="counter">
      <button type="button" class="btn" (click)="decrement('child')" [disabled]="child <= 0">−</button>
      <div class="value">{{ child }}</div>
      <button type="button" class="btn" (click)="increment('child')" [disabled]="child >= 9">+</button>
    </div>
  </div>

  <div class="row">
    <div class="label">
      <div class="title">{{"modals.guest_count_modal.infant" | translate}}</div>
      <div class="subtitle">({{"modals.guest_count_modal.Below" | translate}} 2 {{"modals.guest_count_modal.Years" | translate}})</div>
    </div>
    <div class="counter">
      <button type="button" class="btn" (click)="decrement('infant')" [disabled]="infant <= 0">−</button>
      <div class="value">{{ infant }}</div>
      <button type="button" class="btn" (click)="increment('infant')" [disabled]="infant >= 9">+</button>
    </div>
  </div>

  <ion-button expand="block" class="primary-btn" (click)="confirm()">Confirm</ion-button>
</ion-content>


